import { deleteInventoryTransactionType } from "../../api/inventoryService";

export const useDeleteInventoryTransactionType = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteInventoryTransactionType(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete inventory transaction type:", error);
            throw error;
        }
    };

    return { remove };
};